<template>
<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.8847 1.87506C10.9328 1.5625 9.58728 1.5625 7.46728 1.5625C4.5657 1.5625 3.1149 1.5625 2.13842 2.36388C1.95966 2.51059 1.79575 2.6745 1.64904 2.85327C0.847656 3.82975 0.847656 5.28054 0.847656 8.18212V9.06474C0.847656 11.4695 0.847656 12.3827 1.30385 13.3503M14.0869 6.30845C14.1195 7.00284 14.0869 7.18432 14.0869 8.18212V9.06474C14.0869 11.9663 14.0869 13.4171 13.2855 14.3936C13.1388 14.5724 12.9749 14.7363 12.7962 14.8829C11.8196 15.6844 10.3689 15.6844 7.46728 15.6844C6.25146 15.6844 5.74698 15.6844 4.96877 15.6254" stroke="white" stroke-linecap="round"/>
<path d="M14.1977 6.60887L14.668 6.12641C16.3854 5.26768 17.2442 4.83831 17.8721 5.22637C18.5 5.61443 18.5 6.57453 18.5 8.49473V8.75228C18.5 10.6725 18.5 11.6325 17.8721 12.0206C17.2442 12.4087 16.3854 11.9793 14.668 11.1206L14.0869 10.83L14.1977 6.60887Z" stroke="white"/>
<line x1="0.5" y1="17.2665" x2="17.2668" y2="0.499775" stroke="white" stroke-linecap="round"/>
</svg>
</template>

<script>
export default {
  name: 'IconCameraSlash'
}
</script>
